export default __webpack_public_path__ + "static/media/thumbnail.1f013c5a.jpg";